var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnhold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.43 60.88",
    style: {
      enableBackground: "new 0 0 51.43 60.88"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.97,25.9c-2.97,0-5.48,2.01-7.33,3.81c-0.51,0.5-1.01,1.03-1.49,1.55V10.4c0-3.29-2.64-6-5.94-6 c-0.76,0-1.49,0.14-2.16,0.41c-0.69-2.53-2.98-4.41-5.73-4.41c-3.31,0-5.94,2.71-5.94,6v1.33c-0.61-0.21-1.26-0.33-1.94-0.33 c-3.31,0-5.94,2.71-5.94,6v1.33c-0.61-0.21-1.26-0.33-1.94-0.33c-3.31,0-5.94,2.71-5.94,6v24c0,0,0,0.01,0,0.01v1.99 c0,7.71,6.17,14,13.83,14h15.06c6.04,0,11.3-3.95,13.14-9.62c0.05-0.16,0.1-0.31,0.15-0.46c0.22-0.7,0.41-1.27,0.66-1.83l6.68-14.83 c0.18-0.4,0.43-1.02,0.47-1.75C50.78,28.73,48.29,25.9,44.97,25.9z M46.58,31.74c-1.9,6.22-5.74,11.61-7.75,17.8 c-1.32,4.07-5.07,6.86-9.34,6.86H14.43c-5.41,0-9.83-4.45-9.83-10c0-8.67,0-17.33,0-26c0-1.13,0.9-2,1.94-2c1.05,0,1.94,0.87,1.94,2 v13.5c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V13.4c0-1.13,0.9-2,1.94-2c1.05,0,1.94,0.87,1.94,2v19c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-26 c0-1.13,0.9-2,1.94-2c1.05,0,1.94,0.87,1.94,2v25.5c0,0,0,0.01,0,0.01v1.99c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V10.4 c0-1.13,0.9-2,1.94-2c1.05,0,1.94,0.87,1.94,2v26c0,0.8,0.48,1.52,1.21,1.84c0.74,0.32,1.59,0.16,2.17-0.39 c0.75-0.72,1.55-1.62,2.32-2.49l0.09-0.1c0.82-0.93,1.65-1.86,2.5-2.69c1.81-1.77,3.29-2.67,4.53-2.67c0.92,0,1.68,0.8,1.63,1.77 C46.59,31.67,46.59,31.69,46.58,31.74z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnhold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onhold.cee78ed77dc0181c0b795be615d95ea9.svg";